<template>
  <rest-list-page
    :breadcrumbs="breadcrumbs"
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
  >
    <template slot="actions">
      <el-button
        type="primary"
        icon="el-icon-plus"
        @click="addRow"
        v-if="!readonly && $can('createProjectItem')"
      >
        {{ $t('Lists_ListItemsList_Create') }}
      </el-button>

      <el-button type="primary" icon="el-icon-download" @click="exportList">
        {{ $t('Lists_ListItemsList_Export') }}
      </el-button>

      <el-button
        type="primary"
        icon="el-icon-upload"
        @click="$refs.fileInput.click()"
        v-if="!readonly"
      >
        {{ $t('Lists_ListItemsList_Import') }}
        <input
          ref="fileInput"
          type="file"
          style="display: none"
          accept=".csv"
          @change="importList($event)"
        />
      </el-button>
    </template>

    <template slot="list">
      <rest-list-editable
        :payload="fetchEndpoint"
        ref="rest-list-editable"
        :rules="rules"
        :add-endpoint="addEndpoint"
      >
        <rest-list-column
          :editable="true"
          prop="value"
          :title="$t('ListItem_Field_Value')"
          :filterable="true"
        />

        <rest-list-column-actions v-if="!readonly" :editable="true">
          <template slot-scope="scope">
            <rest-list-action-delete
              :name="scope.row.value"
              :endpoint="rowDeleteEndpoint(scope.row)"
            />
          </template>
        </rest-list-column-actions>
      </rest-list-editable>
    </template>
  </rest-list-page>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import RestListPage from '@/common/components/rest/RestListPageNew'
import RestListColumn from '@/common/components/rest/RestListColumn'
import RestListColumnActions from '@/common/components/rest/RestListColumnActions'
import RestListActionDelete from '@/common/components/rest/RestListActionDelete'

import { projectEndpoint, projectRoute, projectUrl } from '@/core/helpers'
import RestListEditable from '@/common/components/rest/RestListEditable'

export default {
  components: {
    RestListEditable,
    RestListPage,
    RestListColumn,
    RestListColumnActions,
    RestListActionDelete
  },

  props: {
    suppression: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      label: '',
      rules: {
        value: {
          required: true
        }
      }
    }
  },

  created() {
    RestApi.get(projectUrl(`lists/${this.$route.query.list_id}`)).then(
      ({ data }) => {
        this.label = data.name
      }
    )
  },

  computed: {
    breadcrumbs() {
      return [
        { label: this.$t('ListItem_Breadcrumb_Data') },
        { label: this.$t('ListItem_Breadcrumb_Segments') },
        {
          label: this.suppression
            ? this.$t('ListItem_Breadcrumb_SuppressionLists')
            : this.$t('ListItem_Breadcrumb_UserLists'),
          route: projectRoute({
            name: this.suppression ? 'SuppressionLists' : 'UserLists'
          })
        },
        { label: this.label }
      ]
    },
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    addEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: `list/${this.$route.query.list_id}/items`
      })
    },
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `list/${this.$route.query.list_id}/items`,
        params: {}
      })
    },

    readonly() {
      return !this.$can('updateProjectItem')
    }
  },

  methods: {
    rowDeleteEndpoint(row) {
      return projectEndpoint({
        method: 'delete',
        url: `list/${this.$route.query.list_id}/items/${row.value}`
      })
    },

    addRow() {
      this.$refs['rest-list-editable'].addRow({
        list_id: this.$route.query.list_id,
        value: ''
      })
    },

    exportList() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `list/${this.$route.query.list_id}/export`
        })
      )
        .then(({ data }) => {
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },

    importList(event) {
      const formData = new FormData()
      formData.append('file', event.target.files[0])

      RestApi(
        projectEndpoint({
          method: 'post',
          url: `list/${this.$route.query.list_id}/import`,
          config: { headers: { 'Content-Type': 'multipart/form-data' } },
          data: formData
        })
      )
        .then(({ data }) => {
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/lists/pages/ListItemsPage.vue